import deliveringActions from '../actions/DeliveringActions';

function setOfflineFileDeliveryStatus(state, assessmentRunId, status) {
    const aridData = state.offlineFileDeliveryStatus[assessmentRunId] || {};
    const offlineFileDeliveryStatus = {
        ...state.offlineFileDeliveryStatus,
        [assessmentRunId]: { ...aridData, status },
    };
    return { ...state, offlineFileDeliveryStatus };
}

function setOfflineFileDeliveryObject(state, assessmentRunId, deliveryObject) {
    const aridData = state.offlineFileDeliveryStatus[assessmentRunId] || { status: deliveringActions.statuses.PENDING };
    const offlineFileDeliveryStatus = {
        ...state.offlineFileDeliveryStatus,
        [assessmentRunId]: { ...aridData, deliveryObject },
    };
    return { ...state, offlineFileDeliveryStatus };
}

const defaultState = { actionInProgress: undefined, offlineFileDeliveryStatus: {} };
export default function deliverReducer(state = defaultState, action) {
    switch (action.type) {
    case deliveringActions.types.DELIVERING_CHECK_STORED_ITEMS_COMPARE_SUCCESS:
        return Object.assign({}, state, {
            responseVerificationSuccess: true,
            storedItemsStatus: action.storedItemsStatus,
            differences: null, // remove previous differences if any
        });

    case deliveringActions.types.DELIVERING_CHECK_STORED_ITEMS_COMPARE_FAILED:
        return Object.assign({}, state, {
            responseVerificationSuccess: false,
            storedItemsStatus: action.storedItemsStatus,
            differences: action.differences,
        });

    case deliveringActions.types.DELIVERING_SET_ACTION_IN_PROGRESS:
        return Object.assign({}, state, { actionInProgress: action.actionInProgress });

    case deliveringActions.types.DELIVERING_RESET_DELIVER_STATE:
        return {};

    case deliveringActions.types.DELIVERING_SET_HAS_DELIVERED:
        return Object.assign({}, state, { hasDelivered: action.hasDelivered });

    case deliveringActions.types.DELIVERING_SET_OFFLINE_FILE_DELIVERY_STATUS:
        return setOfflineFileDeliveryStatus(state, action.assessmentRunId, action.status);

    case deliveringActions.types.DELIVERING_SET_OFFLINE_FILE_DELIVERY_OBJECT:
        return setOfflineFileDeliveryObject(state, action.assessmentRunId, action.deliveryObject);

    default:
        return state;
    }
}
